module.exports = __webpack_public_path__ + "media/Loops 110 Perc.3ce564d8.wav";